import React from 'react';
import { motion } from 'framer-motion';
import { Volume2, Music, Mic } from 'lucide-react';

export function AudioLoadingAnimation() {
  return (
    <div className="flex items-center gap-4">
      {/* Sound wave animation */}
      <div className="flex items-center gap-1">
        {[...Array(4)].map((_, i) => (
          <motion.div
            key={i}
            className="w-1 bg-teal-500 rounded-full"
            animate={{
              height: ["12px", "24px", "12px"],
            }}
            transition={{
              duration: 0.8,
              delay: i * 0.1,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
      
      {/* Animated icons */}
      <motion.div
        className="relative"
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <Volume2 className="w-5 h-5 text-teal-600" />
        
        {/* Floating notes */}
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            initial={{
              opacity: 0,
              scale: 0,
              x: 0,
              y: 0,
            }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1, 0],
              x: [0, (i - 1) * 15],
              y: [0, -15, -30],
            }}
            transition={{
              duration: 2,
              delay: i * 0.4,
              repeat: Infinity,
              ease: "easeOut",
            }}
            style={{
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Music className="w-3 h-3 text-blue-500" />
          </motion.div>
        ))}
      </motion.div>
      
      <span className="text-sm font-medium text-gray-600">Creating Audio...</span>
    </div>
  );
}